import {
  FETCH_YEARBOOK_POSES_REQUEST,
  FETCH_YEARBOOK_POSES_SUCCESS,
  FETCH_YEARBOOK_POSES_FAILURE,
  SKIP_YEARBOOK_SELECTION,
} from '../actions/yearbook';

const INITIAL_STATE = {
  poses: [],
  loading: false,
  error: null,
};

export default function yearbookPoses(state = INITIAL_STATE, action) {
  Object.freeze(state);

  switch (action.type) {
    case FETCH_YEARBOOK_POSES_REQUEST:
      return {
        ...state,
        loading: true,
        poses: null,
        error: null,
      };

    case FETCH_YEARBOOK_POSES_SUCCESS:
      return {
        ...state,
        loading: false,
        poses: action.payload,
        error: null,
      };

    case FETCH_YEARBOOK_POSES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case SKIP_YEARBOOK_SELECTION:
      return {
        ...state,
        ...action.payload,
      };

    default:
      return state;
  }
}
